module.exports = __webpack_public_path__ + "static/media/graphisual.ac51bed0.svg";